import React, { useState, useEffect, FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

// d.ts
import { IDataController, DCRecord } from "@/@types/lib/dataController"

// Custom Components
import ModelTable from "@/ui/Table/ModelTable";

import api from "@/lib/api";
import { downloadFile } from "@/lib/downloadFile";
import dataController from "@/lib/dataController";

// Types
import { IModel } from "@/@types/models/model";

// TODO:
// subModels cleanup: they are added to the project because Table.jsx can not function without them


interface IObjectAnalysisTableProps {
  records: Array<DCRecord>;
  onRowSelect: (id: number, record: DCRecord) => void;
  // onLoad?: (records: Array<DCRecord>) => void;
  lokacijaId?: number;
  selectedObjektId?: number;

  model: IModel;
  titleToken: string;
  viewName?: string
}

let CHANGED_FLAG = false;

const ObjectAnalysisTable: FunctionComponent<React.PropsWithChildren<IObjectAnalysisTableProps>> = (props) => {
  const { t } = useTranslation();
  const { records, onRowSelect, lokacijaId } = props;
  const { model, titleToken, viewName = "object_analysis"} = props;

  // const [records, setRecords] = useState<DCRecord[]>([]);
  const [filteredRecords, setFilteredRecords] = useState<DCRecord[]>([]);
  const [zapisnikDl, setZapisnikDl] = useState<{id: number}>({id: 0});
  const [rowSelected, setRowSelected] = useState<DCRecord|null>(null);
  const [globalFilter, setGlobalFilter] = useState<string|undefined>();

  const dc: IDataController = new dataController(model);

  const locationField = "id";

  // useEffect(() => {
  //   refreshRecords();
  // }, []);

  useEffect(() => {
    const { id } = zapisnikDl;
    if (id === 0) {
      // do error logging
      return;
    }
    const record = records.find(r => r.id === id);
    if (!record) {
      // do error logging
      return;
    }
    const koName = record.obv ? record.obv : "";
    const apiInstance = new api();
    const path = `${model.apiPath}/${id}/zapisnik?ko_name=${koName}`;
    downloadFile(path, undefined, `${koName}-${id}.pdf`);
    // apiInstance.Download(path).then((file: unknown) => {
    //   console.log("GOT FILE:");
    //   console.log(file);
    // })

  }, [zapisnikDl]);

  // const refreshRecords = () => {
  //   loaderContext.toggleLoading(true);
  //   dc.GetData()
  //     .then((resp) => {
  //       if (resp.success && Array.isArray(resp.data)) {
  //         const rs = resp.data.map(r => ({...r, ...{ zapisnik_dl: r.zap === '1' ? true : false }}))
  //         setRecords(rs)
  //         setFilteredRecords(rs)
  //         if (resp.data.length === 0) {
  //           snackbarContext.showNotification("messages.nodata", "warning", true);
  //         }
  //       };
  //     })
  //     .catch((resp) => {
  //       console.log(resp);
  //     })
  //     .finally(() => {
  //       loaderContext.toggleLoading(false);
  //     });
  // };

  const handleRowSelect = (id: number) => {
    if (rowSelected === null)
      CHANGED_FLAG = true;
    const record = records.find(r => r.id === id);
    if (record !== undefined) {
      const [rLok, rId] = rowSelected === null ? [-1, -1] : [rowSelected[locationField], rowSelected.id];
      if (record.id === rId && record[locationField] === rLok) {
        setRowSelected(null);
        onRowSelect(Number(record[locationField]), record);
      } else if (record.id !== rId && record[locationField] === rLok) {
        setRowSelected(record);
      }else {
        setRowSelected(record);
        onRowSelect(Number(record[locationField]), record);
      }
    } else {
      setRowSelected(null);
    }
  }

  const handleGlobalFilterChange = (globalFilter: string | undefined) => {
    if (CHANGED_FLAG && !globalFilter) {
      CHANGED_FLAG = false
    } else {
      setGlobalFilter(globalFilter);
    }
  }

  useEffect(() => {
    if (lokacijaId) {
      const fRecords: DCRecord[] = records.filter(r => r[locationField] === lokacijaId);
      setFilteredRecords(fRecords);
      if (fRecords.length > 0) {
        setRowSelected(fRecords[0]);
        // if (onLoad) {
        //   onLoad(fRecords);
        // }
      } else {
        setRowSelected(null);
      }

    } else {
      setFilteredRecords(records)
      setRowSelected(null);
    }
  }, [records, lokacijaId])

  useEffect(() => {
    if (rowSelected !== null) {
      onRowSelect(Number(rowSelected[locationField]), rowSelected);
    }
  }, [globalFilter])

  return (
    <ModelTable
      title={t(titleToken)}
      records={filteredRecords}
      viewName={viewName}
      dc={dc}
      allowSelection="one"
      allowFilter={true}
      allowExport={false}
      allowAdd={false}
      allowEdit={false}
      disableControls={true}
      onRowAction={(action: string) => { console.log(action) }}
      onRowClick={handleRowSelect}
      initialPageSize={25}
      allowRowAction={() => { return true;}}
      trackTableState={false}
      unselectRow={true}
      rowSelectedCustom={rowSelected !== null && rowSelected.id ? (rowSelected.id as number) : -1}
      onGlobalFilterChange={handleGlobalFilterChange}
      customRecordCount={records.length}
      gotoFirstPageOnSelect={true}
    />
  );
}

export default ObjectAnalysisTable;
